export enum LicenseEnum {
	ESUS_PERMANENTLY = 1,
	ESUS_TEMPORARY = 2,
	SINTEGRADA_PERMANENTLY = 3,
}
